<form #form *ngIf="isFormInitialized" class="advanced-form" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="advanced-form__form-error fn-form-error-alert" [mmTestTarget]="'form-alert'"></div>
    <div class="advanced-form__sections">
        <div *ngFor="let formSection of formSectionList;" class="advanced-form__section">
            <div *ngIf="formSection?.title" class="advanced-form__section-title">
                {{ formSection.title | translate }}
            </div>
            <div class="advanced-form__custom-tags">
                <div *ngFor="let tag of formSection.customTagList;" class="advanced-form__field advanced-form__field--{{ tag.name }}">
                    <ng-container [ngSwitch]="tag.type">
                        <div ngClass="{{tag.class}}" *ngSwitchCase="'text'">
                            {{ tag.text | translate }}
                        </div>

                        <app-tooltip [position]="'left'" class="footer-nav__tooltip" *ngSwitchCase="'tooltip'">
                            <span [innerHTML]="tag.text | translate"></span>
                        </app-tooltip>
                    </ng-container>
                </div>
            </div>

            <div class="advanced-form__fields">
                <div *ngFor="let field of formSection.fieldList;" class="advanced-form__field advanced-form__field--{{ field.name }}">
                    <mm-field>
                        <mm-label *ngIf="field.type !== 'checkbox' && field.type !== 'link'" [mmTestTarget]="'input-label-' + field.name">
                            {{ field.label | translate }} {{ field.hasRequiredMark ? mandatoryFieldMark : '' }}
                        </mm-label>

                        <ng-container [ngSwitch]="field.type">
                          <a *ngSwitchCase="'link'"
                             class="advanced-form__edit-link"
                             [ngClass]="{'advanced-form__hide-edit-link': !isFieldDisabled}"
                             tabindex="-1"
                             (click)="makeTextFieldEditable()"
                             [mmTestTarget]="'link-' + field.name">
                            {{ field.label | translate}}
                          </a>

                            <select *ngSwitchCase="'select'"
                                    class="advanced-form__select"
                                    [ngStyle]="selectElementBackground"
                                    [formControlName]="field.name"
                                    [id]="field.id"
                                    [mmTestTarget]="'input-' + field.name">
                                <option *ngFor="let option of field.options" [value]="option.value">
                                    {{ option.label | translate }}
                                </option>
                            </select>

                          <div class="advanced-form__divider" *ngIf="field.name.includes('saveLegalAddressAsShippingAndBilling')"></div>

                            <mm-checkbox *ngSwitchCase="'checkbox'" [formControlName]="field.name">
                                <span [innerHTML]="field.label | translate "></span>
                            </mm-checkbox>

                            <mm-field *ngSwitchCase="'radio'">
                                <mm-radio
                                    [ngClass]="{'mm-field--error': formGroup.controls[field.name].touched
                                    && formGroup.controls[field.name].invalid}"
                                    *ngFor="let option of field.options"
                                    [formControlName]="field.name"
                                    [value]="option.value">
                                    {{ option.label | translate }}
                                </mm-radio>
                            </mm-field>

                            <app-password-field *ngSwitchCase="'password'"
                                                [autoCompletePassword]="field.autoCompletePassword"
                                                [formControlName]="field.name"
                                                [placeholder]="field.placeholder"></app-password-field>

                                                <app-autocomplete-field
                                                *ngSwitchCase="'autocomplete'"
                                                [search]="field.search"
                                                [id]="field.id"
                                                [formControlName]="field.name"
                                                [placeholder]="field.placeholder | translate"
                                                [onOptionClick]="field.onOptionClick"
                                                [onFocus]="field.onFocus"
                                                [getItemPrefixUrl]="field.getItemPrefixUrl"
                                              ></app-autocomplete-field>

                            <app-metro-card-field *ngSwitchCase="'metrocard'"
                                                  [formControlName]="field.name"></app-metro-card-field>

                            <ng-container *ngSwitchDefault>
                                <input #inputTextElement
                                    mmInput
                                       autocomplete="{{isFieldDisabled && checkWhetherFieldIsPrefilledFormControl(field.name) ? 'chrome-off' : null}}"
                                    [disabled]="isFieldDisabled && checkWhetherFieldIsPrefilledFormControl(field.name)"
                                    [ngClass]="{'advanced-form__field-disabled':
                                    isFieldDisabled && checkWhetherFieldIsPrefilledFormControl(field.name)}"
                                    [type]="field.type || 'text'"
                                    [formControlName]="field.name"
                                    [appNoSpaces]="(isNoSpacesFieldEnabled$ | async) ? field.noSpaces || false : false"
                                    [placeholder]="field.placeholder | translate"
                                    [id]="field.id"
                                    [mmTestTarget]="'input-' + field.name">
                            </ng-container>

                        </ng-container>

                        <span *ngIf="field.helpText" class="advanced-form__help-text">{{field.helpText | translate}}</span>

                        <mm-error
                            *ngIf="formGroup.controls[field.name].touched && formGroup.controls[field.name].invalid"
                            [fieldName]="field.name"
                            [mmTestTarget]="'input-error-' + field.name">
                            {{ formGroup.controls[field.name].errors | errorMessage: field.name }}
                        </mm-error>
                    </mm-field>

                    <app-password-strength-visualizer
                            *ngIf="field.type === 'password' && field.isVisiblePasswordStrengthVisualiser"
                            [passwordErrors]="formGroup.get(field.name).errors && formGroup.get(field.name).errors.security"
                    ></app-password-strength-visualizer>

                    <ng-container *ngIf="field.specialLinks" >
                        <div *ngFor="let link of field.specialLinks" class="advanced-form__special-link-container">
                            <a class="advanced-form__special-link"
                               tabindex="-1"
                               [routerLink]="link.url"
                               [target]="link.target || '_self'"
                               [mmTestTarget]="'input-link-' + field.name">
                                {{link.text | translate}}
                            </a>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="hasFieldWithMandatoryMark" class="advanced-form__mandatory-note">
      {{ mandatoryFieldMark }} {{ 'REGULAR.MANDATORY_FIELD' | translate }}
    </div>

    <div *ngIf="legalText" class="advanced-form__legal-text">
      {{ legalText | translate }}
    </div>

    <div class="advanced-form__actions">
        <ng-container *ngFor="let button of config.actionList">
            <button
                *ngIf="button.type === 'submit'"
                mm-button
                fluid="true"
                class="advanced-form__action"
                type="submit"
                [loading]="isSubmitting"
                [mmTestTarget]="'button-submit'">
                {{ button.text | translate }}
            </button>
            <button
                *ngIf="button.type !== 'submit'"
                mm-button
                fluid="true"
                class="advanced-form__action"
                [color]="button?.extras?.color || 'ghost'"
                [size]="button?.extras?.size || 'medium'"
                (click)="emitEvent(button.type)"
                [mmTestTarget]="'button-' + button.type">
                {{ button.text | translate }}
            </button>
        </ng-container>
    </div>
</form>
